// extracted by mini-css-extract-plugin
export default {"slide-button":"SlideButton_slide-button__I44NC"};